import Axios from "../../../axios.js";
import {noticeApiConstants} from "../../../constants/ApiConstant";


export async function saveNotice(params) {
    return Axios.post(noticeApiConstants.SAVE_NOTICE, params);
}

export async function searchNotice(params, page, size) {
    return Axios.post(noticeApiConstants.SEARCH_NOTICES + `?page=${page}&size=${size}`, params);
}

export async function deleteNotice(params) {
    return Axios.post(noticeApiConstants.DELETE_NOTICE, params);
}
